/* Avalon sections: reuse the theme's own scroll animation (fade up, staggered).
   The theme animates anything inside `.animation` once it has `.is-visible`, so this script
   tags the right containers and adds `.is-visible` when each section scrolls into view. */
(function () {
  var SECTION = '.animation[data-section-type^="avalon-"]';
  var INTRO = [
    '.avalon-picks__header', '.avalon-stylecards__header', '.avalon-banner__content', '.avalon-statement__content',
    '.avalon-spot__text', '.avalon-about__text', '.avalon-benefits__content', '.avalon-oak__panel',
    '.avalon-info__col', '.avalon-testi__text', '.avalon-car__heading', '.avalon-promo__grid .avalon-panel__content'
  ].join(',');
  var BLOCKS = [
    '.avalon-picks__grid', '.avalon-stylecards__grid', '.avalon-promo__grid', '.avalon-trust__list',
    '.avalon-benefits__features', '.avalon-oak__products', '.avalon-grid__products', '.avalon-car__track', '.avalon-tiles__grid'
  ].join(',');

  function prepare(section) {
    if (section.dataset.avalonAnimated) return;
    section.dataset.avalonAnimated = 'true';
    // Start from the hidden state without a visible fade-out first.
    section.classList.add('avalon-anim-prep');
    var release = function () { section.classList.remove('avalon-anim-prep'); };
    setTimeout(release, 120);

    section.querySelectorAll(INTRO).forEach(function (node) {
      node.classList.add('animation--section-introduction');
      Array.prototype.forEach.call(node.children, function (child, i) {
        child.style.setProperty('--delay-offset-multiplier', i);
      });
    });

    section.querySelectorAll(BLOCKS).forEach(function (node) {
      node.classList.add('animation--section-blocks');
      Array.prototype.forEach.call(node.children, function (child, i) {
        child.style.setProperty('--delay-offset-multiplier', i);
      });
    });

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      return;
    }

    var margin = window.matchMedia('(min-width: 720px)').matches ? 200 : 100;
    var threshold = Math.min(margin / Math.max(section.offsetHeight, 1), 0.5);
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        section.classList.add('is-visible');
        observer.disconnect();
      }
    }, { threshold: threshold });
    observer.observe(section);

    // Never leave a section hidden if the observer does not fire.
    setTimeout(function () {
      if (section.getBoundingClientRect().top < window.innerHeight) section.classList.add('is-visible');
    }, 2500);
  }

  function init(root) {
    (root || document).querySelectorAll(SECTION).forEach(prepare);
  }

  if (!document.documentElement.classList.contains('do-anim')) return;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
